import { Avatar as AvatarMui, Box, Typography } from '@mui/material';
import { ConditionalLoader } from 'dashboard409a/pages/Operations/components';
import { getInitials } from 'utilities/getInitials';
import { AvatarContainer } from './Avatar.styles';

interface AvatarProps {
  src: string;
  name: string;
  roleTitle: string;
  isLoading?: boolean;
}

const Avatar = ({ src, name, roleTitle, isLoading }: AvatarProps) => (
  <AvatarContainer>
    <AvatarMui alt={name} src={src} sx={{ width: 32, height: 32, fontSize: '0.75rem' }}>
      {getInitials({ name })}
    </AvatarMui>
    <Box>
      <ConditionalLoader isLoading={isLoading} width={150} height={16}>
        <Typography fontWeight="bold" fontSize="0.8rem">{name}</Typography>
      </ConditionalLoader>
      <ConditionalLoader isLoading={isLoading} width={100} height={14}>
        <Typography fontSize="0.75rem" color="text.secondary">
          {roleTitle}
        </Typography>
      </ConditionalLoader>
    </Box>
  </AvatarContainer>
);

export default Avatar;
